import { combineReducers } from 'redux';
import filters from './filters';
import transactions from './transactions';

const reducer = combineReducers({
  filters,
  transactions
});

export default reducer;
